export enum ConnectTypeCodetable {
  LocationConnectType = 40,
  LocationNode = 32,

  UnitConnectType = 146,
  UnitNode = 144,

  ShutdownConnectType = 148,
  ShutdownNode = 137,

  ChecklistConnectType = 264,
  ChecklistNode = 262,

  WorkProcessConnectType = 272,
  WorkProcessNode = 270,

  SubstanceConnectType = 342,
  SubstanceNode = 339,

  BarrierConnectType = 384,
  BarrierNode = 383,

  CompanyConnectType = 415,
  Company = 37,

  ActionStatusConnectType = 429,
  ActionStatus = 188,
  
  EvaluationConnectType = 259,
  Evaluation = 260
}

export const connectType: { [codetable: number]: number } = {
  [ConnectTypeCodetable.LocationConnectType]: ConnectTypeCodetable.LocationNode,
  [ConnectTypeCodetable.UnitConnectType]: ConnectTypeCodetable.UnitNode,
  [ConnectTypeCodetable.ShutdownConnectType]: ConnectTypeCodetable.ShutdownNode,
  [ConnectTypeCodetable.ChecklistConnectType]: ConnectTypeCodetable.ChecklistNode,
  [ConnectTypeCodetable.WorkProcessConnectType]: ConnectTypeCodetable.WorkProcessNode,
  [ConnectTypeCodetable.SubstanceConnectType]: ConnectTypeCodetable.SubstanceNode,
  [ConnectTypeCodetable.BarrierConnectType]: ConnectTypeCodetable.BarrierNode,
  [ConnectTypeCodetable.CompanyConnectType]: ConnectTypeCodetable.Company,
  [ConnectTypeCodetable.ActionStatusConnectType]: ConnectTypeCodetable.ActionStatus,
  [ConnectTypeCodetable.EvaluationConnectType]: ConnectTypeCodetable.Evaluation
} as const;
